import type { CSSProperties, ReactNode } from 'react';
import { Flex } from 'reflexbox';

import { tokens } from '../theme/tokens';

export function DataCard({
	background,
	color,
	style,
	children,
}: {
	background: string;
	color?: string;
	style?: CSSProperties;
	children: ReactNode;
}) {
	return (
		<Flex
			style={{
				alignItems: 'center',
				justifyContent: 'center',
				width: 32,
				height: 32,
				borderRadius: 10,
				fontWeight: 600,
				fontSize: 15,
				background,
				color: color ?? tokens.text.primary,
				transition: 'background-color 600ms ease',
				...style,
			}}
		>
			{children}
		</Flex>
	);
}
